import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { CrimeGunService } from 'src/app/services/crime-gun.service';
import { SearchResultType } from 'src/app/shared/app.enums';
import { environment } from 'src/environments/environment';
import { AppConstants } from '../../app.constants';
import { AppPermissions } from '../../app.permissions';
import { AlertMenuItem } from '../../models/alert-menu-item';

@Component({
  selector: 'ness-nibin-case-data',
  templateUrl: './nibin-case-data.component.html'
})
export class NIBINCaseDataComponent {
  @Input() alertMenuItems: AlertMenuItem[] = [];

  @Output() showNIBINCaseData = new EventEmitter<boolean>();
  @Output() showDetails: EventEmitter<{ detailType: SearchResultType, dataId: string }> = new EventEmitter();

  readonly canEditCrimeGun = AppPermissions.canEditCrimeGun;
  readonly canViewCrimeGun = AppPermissions.canViewCrimeGun;

  cols = [
    { header: 'Exhibit #', field: 'ExhibitReferenceNumber' },
    { header: 'Caliber Evidence Category', field: 'CaliberCode' },
    { header: 'Reception Date', field: 'ReceptionDate' },
    { header: 'Acquisition Date', field: 'AcquisitionTime' },
    { header: 'Acquisition Tech', field: 'NIBINCreationUser' },
    { header: 'Removed', field: 'Removed' },
    { header: 'POE Comments', field: 'Comments' },
    { header: 'Firearm Manufacturer; Model; Serial #', field: 'ManufacturerCode' },
    { header: 'Firearm Acquisition Tech', field: 'FirearmAcquisitionTech' },
    { header: 'Firearm Comments', field: 'FirearmComment' },
    { header: 'CGID', field: 'CrimeGunNumber' }
  ];
  rows: number = AppConstants.defaultTableRows;
  showFullComment: boolean = false;
  targetComment: Subject<{ headerText: string, commentText: string }> = new Subject<{ headerText: string, commentText: string }>();
  targetComment$ = this.targetComment.asObservable();
  searchResultType = SearchResultType;

  readonly isSLUser: boolean = this.authService.hasUserType(['StateLocalLE']);

  constructor(public crimeGunService: CrimeGunService,
    private authService: AuthService) { }

  public openRelatedCrimeGun(evt: Event, id: string): void {
    evt.preventDefault();
    const token = sessionStorage.getItem(environment.authTokenStorageKey);
    let url = (<HTMLLinkElement>evt.target).baseURI + '/crimegun/' + id;
    let windowObjRef = window.open(url, '_blank');
    windowObjRef.sessionStorage.setItem(environment.authTokenStorageKey, token);
  }

  public showFullCommentText(commentObj: { headerText: string, commentText: string }): void {
    this.showFullComment = true;
    this.targetComment.next(commentObj);
  }

  public getFirearmObject(poe: ServerModels.ENESS_NIBINPiecesOfEvidenceDTO): string {
    if (Object.keys(poe).length == 0 || (!poe.ManufacturerCode && !poe.ModelDescription && !poe.SerialNumber)) {
      return '';
    }

    let firearmMMSN: string[] = [];
    firearmMMSN.push(!poe.ManufacturerCode?.trim() ? '[Blank]' : poe.ManufacturerCode);
    firearmMMSN.push(!poe.ModelDescription?.trim() ? '[Blank]' : poe.ModelDescription);
    firearmMMSN.push(!poe.SerialNumber?.trim() ? '[Blank]' : poe.SerialNumber);

    return firearmMMSN.join('; ');
  }

  public getCaliberEvidenceCategory(poe: ServerModels.ENESS_NIBINPiecesOfEvidenceDTO): string {
    return !!poe?.CaliberCode ? `${poe.CaliberCode} ${poe.EvidenceClassCode}` : '';
  }

}
